var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 323,
    height: 487,
    fill: "none",
    viewBox: "0 0 323 487",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 323,
    height: 487,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M0 0h323v487H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9dcac",
    d: "M30.361-109.684c-31.87 16.203-48.44 150.51-48.69 152.604-.25 2.093-.929 9.133-.929 9.133s-21.36 262.535 2.13 300.104c23.492 37.569-9.956 97.868-9.956 97.868s59.502 43.64 125.61 28.288a123 123 0 0 0 19.712-6.361 128 128 0 0 0 14.53-7.203c6.151-3.547 12.286-7.745 18.353-12.671 46.313-37.581 56.062-75.698 56.545-107.76.391-25.583-5.121-47.308-2.656-61.829 5.549-32.718 72.646-36.354 102.777-131.705 6.011-19.024 10.61-40.604 12.92-62.396 6.463-60.917-4.916-123.508-53.093-136.65-6.952-1.896-14.665-2.762-23.203-2.445-6.032.218-12.474 1.033-19.349 2.493-12.761 2.702-36.988 15.375-52.844 22.866C121.6-1.43 127.265-47.88 111.982-84.046a179 179 0 0 0-1.945-4.444c-11.762-25.898-47.806-37.398-79.676-21.194"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.7deacfcc157dcd503d1a5e9cc5c3f30d.svg";
export { ForwardRef as ReactComponent };